<template>
  <drr
    :id="ID"
    :x="parseInt(Left)"
    :y="parseInt(Top)"
    :w="parseInt(Width)"
    :h="parseInt(Height)"
    :angle="parseInt(Angle)"
    :aspectRatio="false"
    :z="0"
    :selectable="Enabled"
    v-on:resizestop="resize"
    v-on:dragstop="drag"
    v-on:rotatestop="rotate"
    class="componenteBombaPoco"
  >
    <div class="center">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        :id="`${this.ID}-svg-bomba-poco`"
        :height="Height"
        :width="Width"
        viewBox="0 0 63 76"
        version="1.1"
        inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
        sodipodi:docname="bomba_poco.svg"
      >
        <defs id="defs2">
          <linearGradient inkscape:collect="always" id="linearGradient909">
            <stop
              style="stop-color:#333333;stop-opacity:1"
              offset="0"
              id="stop905"
            />
            <stop
              style="stop-color:#ffffff;stop-opacity:1"
              offset="1"
              id="stop907"
            />
          </linearGradient>
          <linearGradient inkscape:collect="always" id="linearGradient832">
            <stop
              style="stop-color:#40616b;stop-opacity:1"
              offset="0"
              id="stop828"
            />
            <stop
              style="stop-color:#aacbd5;stop-opacity:1"
              offset="1"
              id="stop830"
            />
          </linearGradient>
          <linearGradient
            inkscape:collect="always"
            xlink:href="#linearGradient832"
            id="linearGradient834"
            x1="85.61161"
            y1="140.32889"
            x2="99.029762"
            y2="140.23439"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
            gradientTransform="matrix(1.0085469,0,0,1,-24.004545,-16.933333)"
          />
          <linearGradient
            inkscape:collect="always"
            xlink:href="#linearGradient832"
            id="linearGradient842"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(0.26103934,0,0,0.12699216,-137.87698,140.82735)"
            x1="84.383263"
            y1="123.31987"
            x2="115.84978"
            y2="123.31987"
            spreadMethod="pad"
          />
          <linearGradient
            inkscape:collect="always"
            xlink:href="#linearGradient832"
            id="linearGradient834-5"
            x1="85.61161"
            y1="140.32889"
            x2="99.029762"
            y2="140.23439"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
            gradientTransform="matrix(3.8118308,0,0,3.7795276,-321.65442,-466.09111)"
          />
          <linearGradient
            inkscape:collect="always"
            xlink:href="#linearGradient909"
            id="linearGradient911"
            x1="259.75"
            y1="510.76971"
            x2="376.53033"
            y2="513.06262"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
            gradientTransform="matrix(0.26458333,0,0,0.26458333,-23.283333,-16.933333)"
          />
          <linearGradient
            inkscape:collect="always"
            xlink:href="#linearGradient832"
            id="linearGradient842-3"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(0.98660539,0,0,0.47997037,-83.252988,-59.189884)"
            x1="85.61161"
            y1="140.32889"
            x2="112.20625"
            y2="141.27612"
            spreadMethod="pad"
          />
          <linearGradient
            inkscape:collect="always"
            xlink:href="#linearGradient832"
            id="linearGradient1016"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(0.26103934,0,0,0.12699216,85.608276,140.82735)"
            x1="4.0097399"
            y1="123.31891"
            x2="35.47625"
            y2="123.31891"
            spreadMethod="pad"
          />
        </defs>
        <sodipodi:namedview
          id="base"
          pagecolor="#ffffff"
          bordercolor="#666666"
          borderopacity="1.0"
          inkscape:pageopacity="0.0"
          inkscape:pageshadow="2"
          inkscape:zoom="1.4142136"
          inkscape:cx="248.95487"
          inkscape:cy="126.30518"
          inkscape:document-units="mm"
          inkscape:current-layer="Layer1176"
          showgrid="false"
          inkscape:window-width="1366"
          inkscape:window-height="705"
          inkscape:window-x="-8"
          inkscape:window-y="79"
          inkscape:window-maximized="1"
        />
        <metadata id="metadata5">
          <rdf:RDF>
            <cc:Work rdf:about="">
              <dc:format>image/svg+xml</dc:format>
              <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
              <dc:title />
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <g
          inkscape:label="Bomba Poço"
          inkscape:groupmode="layer"
          id="layer1"
          transform="translate(0,-221)"
        >
          <g
            id="g991"
            inkscape:label="Bomba"
            style="display:inline"
            transform="matrix(0.99472664,0,0,0.99472664,-39.378555,138.46834)"
          >
            <rect
              inkscape:label="cilindro_principal"
              ry="0"
              y="106.3866"
              x="61.099854"
              height="33.3564"
              width="31.735458"
              id="rect826"
              style="display:inline;opacity:1;vector-effect:none;fill:url(#linearGradient834);fill-opacity:1;stroke:none;stroke-width:0.49623388;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
            />
            <path
              inkscape:label="fundo_metal"
              inkscape:connector-curvature="0"
              id="rect866"
              d="m 69.980224,83.719955 v 5.524724 h 1.110009 v 4.487066 H 58.662569 v 7.698755 h -2.969845 v 5.34799 h 1.816426 v 32.77681 h -1.737879 v 4.41007 h -2.19728 v -9.45265 h -11.07581 v 9.45265 H 40.46988 v 5.19607 h 16.441891 v 9.45988 h 40.402184 v -9.45988 h 4.724775 v -5.19607 h -3.34088 v -4.41007 h -2.068092 v -32.77681 h 1.990061 v -5.34799 h -3.66541 V 93.731745 H 83.256047 v -4.487066 h 1.27589 V 83.719955 Z M 59.469755,106.77849 H 76.596874 V 139.5553 H 59.469755 Z m 18.516181,0 h 16.56488 v 32.77681 h -16.56488 z"
              style="display:inline;opacity:1;vector-effect:none;fill:url(#linearGradient911);fill-opacity:1;stroke:#000000;stroke-width:0.49623388;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              sodipodi:nodetypes="ccccccccccccccccccccccccccccccccccccccccccccccc"
            />
            <g
              transform="translate(-23.283333,-16.404167)"
              style="display:inline;fill:#4d4d4d"
              inkscape:label="marcas_cilindro"
              id="g968"
            >
              <rect
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
                id="rect938"
                width="7.7886715"
                height="2.166276"
                x="82.351562"
                y="166.51082"
                inkscape:label="marcas_pretas_base_cilindro"
              />
              <rect
                inkscape:label="marcas_pretas_base_cilindro"
                y="166.51082"
                x="96.109894"
                height="2.166276"
                width="7.7886715"
                id="rect940"
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              />
              <rect
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
                id="rect942"
                width="7.7886715"
                height="2.166276"
                x="110.52969"
                y="166.51082"
                inkscape:label="marcas_pretas_base_cilindro"
              />
              <rect
                inkscape:label="marcas_pretas_base_cilindro"
                y="172.2655"
                x="82.351562"
                height="2.166276"
                width="7.7886715"
                id="rect944"
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              />
              <rect
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
                id="rect946"
                width="7.7886715"
                height="2.166276"
                x="96.109894"
                y="172.2655"
                inkscape:label="marcas_pretas_base_cilindro"
              />
              <rect
                inkscape:label="marcas_pretas_base_cilindro"
                y="172.2655"
                x="110.52969"
                height="2.166276"
                width="7.7886715"
                id="rect948"
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              />
              <rect
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
                id="rect950"
                width="7.7886715"
                height="2.166276"
                x="88.966148"
                y="169.42123"
                inkscape:label="marcas_pretas_base_cilindro"
              />
              <rect
                inkscape:label="marcas_pretas_base_cilindro"
                y="169.42123"
                x="102.72448"
                height="2.166276"
                width="7.7886715"
                id="rect952"
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.5161106;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              />
              <rect
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.38642642;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
                id="rect954"
                width="4.3662782"
                height="2.166276"
                x="116.30238"
                y="169.42123"
                inkscape:label="marcas_pretas_base_cilindro"
              />
              <rect
                inkscape:label="marcas_pretas_base_cilindro"
                y="169.42123"
                x="80.153854"
                height="2.166276"
                width="4.1382637"
                id="rect956"
                style="opacity:1;vector-effect:none;fill:#4d4d4d;fill-opacity:1;stroke:none;stroke-width:0.37620121;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              />
            </g>
            <g
              style="display:inline"
              inkscape:label="cilindros_na_base"
              id="g928"
              transform="translate(-23.283333,-16.933333)"
            >
              <rect
                ry="0"
                y="156.48788"
                x="86.654976"
                height="4.2359061"
                width="8.2139997"
                id="rect836"
                style="opacity:1;vector-effect:none;fill:url(#linearGradient1016);fill-opacity:1;stroke:none;stroke-width:0.08996627;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
              />
              <rect
                style="opacity:1;vector-effect:none;fill:url(#linearGradient842);fill-opacity:1;stroke:none;stroke-width:0.08996627;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:0;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers"
                id="rect840"
                width="8.2139997"
                height="4.2360001"
                x="-115.84962"
                y="156.48801"
                ry="0"
                transform="scale(-1,1)"
              />
            </g>
            <g
              style="display:inline;fill:#656b73;fill-opacity:1"
              inkscape:label="sombras"
              id="g936"
              transform="translate(-23.283333,-16.933333)"
            >
              <path
                style="fill:none;fill-opacity:1;stroke:#ababab;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                d="M 65.781514,160.76621 H 76.857325"
                id="path913"
                inkscape:connector-curvature="0"
                inkscape:label="linha_sombra"
              />
              <path
                style="fill:none;fill-opacity:1;stroke:#ababab;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                d="M 79.054604,160.76671 H 121.98118"
                id="path917"
                inkscape:connector-curvature="0"
                inkscape:label="linha_sombra"
              />
              <path
                inkscape:connector-curvature="0"
                id="path919"
                d="M 81.945902,118.23071 H 118.2379"
                style="fill:none;fill-opacity:1;stroke:#ababab;stroke-width:0.26458392px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                sodipodi:nodetypes="cc"
                inkscape:label="linha_sombra"
              />
              <path
                inkscape:label="linha_sombra"
                sodipodi:nodetypes="cc"
                style="fill:none;fill-opacity:1;stroke:#ababab;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                d="M 80.195104,166.22671 H 120.5971"
                id="path930"
                inkscape:connector-curvature="0"
              />
              <path
                inkscape:label="linha_sombra"
                sodipodi:nodetypes="cc"
                style="fill:none;fill-opacity:1;stroke:#ababab;stroke-width:0.26458654px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                d="M 94.373325,110.5328 H 106.53933"
                id="path1018"
                inkscape:connector-curvature="0"
              />
            </g>
            <g
              style="display:inline;fill:#676a6c;fill-opacity:1"
              id="Layer1176"
              transform="matrix(1.620724,0,0,1.620724,-492.55367,-150.87501)"
              inkscape:label="Status"
            >
              <path
                id="path12017"
                style="fill:#676a6c;fill-opacity:1;fill-rule:evenodd"
                d="m 351.5252,149.3002 a 4.7693,4.7693 0 0 1 4.7693,4.7692 4.7693,4.7693 0 1 1 -4.7693,-4.7692 z"
                inkscape:connector-curvature="0"
                inkscape:label="fundo_circular"
              />

              <path
                v-if="Status > 0"
                id="path12019"
                style="display:inline;fill:none;fill-opacity:1;stroke:#00ff00;stroke-width:1.41729999;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none"
                d="m 348.96037,153.21309 c 2.3218,1.954 1.394,3.8811 2.5855,3.1077 1.1914,-0.7735 1.9955,-3.584 2.3036,-5.2518"
                inkscape:connector-curvature="0"
                inkscape:label="On"
              />
              <path
                v-else
                d="m 350.70452,154.01585 -2.11032,-3.07551 h 1.62332 l 1.32571,2.02947 1.33473,-2.02947 h 1.57823 l -2.11031,3.05762 2.2005,3.20069 h -1.62332 l -1.4159,-2.14569 -1.42492,2.14569 h -1.57822 z"
                style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:2.48477888px;line-height:1.25;font-family:'Gotham Bold';-inkscape-font-specification:'Gotham Bold, Bold';letter-spacing:0px;word-spacing:0px;display:inline;fill:#ff0000;fill-opacity:1;stroke:none;stroke-width:0.22448443"
                id="path17661"
                inkscape:connector-curvature="0"
                inkscape:label="Off"
              />
            </g>
          </g>
        </g>
      </svg>
      <p class="nome-bombaPoco">{{ Nome }}</p>
    </div>
  </drr>
</template>

<script>
import drr from "@minogin/vue-drag-resize-rotate";
import datas from "../services/datas";
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "BombaPoco",
  components: {
    drr
  },
  props: {
    ID: { type: String, default: "0" },
    Nome: { type: String, default: "BombaPoco" },
    Status: { type: String, default: "0" },
    Top: { type: String, default: "0" },
    Left: { type: String, default: "0" },
    Width: { type: String, default: "50" },
    Height: { type: String, default: "24" },
    Angle: { type: String, default: "0" },
    Enabled: { type: Boolean, default: false }
  },
  data() {
    return {
      vWidth: { type: String, default: "50" },
      vHeight: { type: String, default: "24" }
    };
  },
  methods: {
    rotate(pos) {
      let id = this.ID;
      datas
        .salvarAngulo(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | ANGLE: ${pos.angle} | TOP: ${pos.y} | LEFT: ${pos.x} | HEIGTH: ${pos.h} | WIDTH: ${pos.w}`,
            "rotate"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Rotate!\n${error}`);
        });
    },
    resize(pos) {
      this.vWidth = pos.w + "";
      this.vHeight = pos.h + "";
      let el = document.getElementById(`${this.ID}-svg-bomba-poco`);
      el.style.width = `${this.vWidth}px`;
      el.style.height = `${this.vHeight}px`;
      let id = this.ID;
      datas
        .salvarTamanho(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | HEIGHT: ${pos.h} | WIDTH: ${pos.w} | ANGLE: ${pos.angle}`,
            "resize"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Resize!\n${error}`);
        });
    },
    drag(pos) {
      let id = this.ID;
      datas
        .salvarPosicao(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | TOP: ${pos.y} | LEFT: ${pos.x} | ANGLE: ${pos.angle}`,
            "drag"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Drag!\n${error}`);
        });
    }
  },
  mounted() {
    this.vWidth = this.Width + "";
    this.vHeight = this.Height + "";
  }
};
</script>

<style>
.componenteBombaPoco {
  position: absolute;
  height: 100px;
  width: 100px;
  cursor: move;
  z-index: 200;
}
.nome-bombaPoco {
  margin: 0;
  padding: 1px;
  text-align: center;
  font-weight: bolder;
  font-size: 13px;
  z-index: 1;
}
</style>
